// extracted by mini-css-extract-plugin
export default {"ProductLoader":"ProductLoader_ProductLoader__1YPS3"};